export default "__VITE_PUBLIC_ASSET__b4906dfd__"